import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

/**
 * Cascading helper: given a district name, fetch its branches.
 * Falls back to [] silently on any error.
 */
export default function useBranches(districtId) {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const reload = useCallback(() => {
    if (!districtId) { setBranches([]); return; }
    setLoading(true);
    return api.get(`/districts/${districtId}/branches`)
      .then(r => setBranches(r.data))
      .catch(() => setBranches([]))
      .finally(() => setLoading(false));
  }, [districtId]);
  useEffect(() => { reload(); }, [reload]);
  return { branches, loading, reload };
}
